mutation DeleteCallrailIntegrationUserSettings {
    callRailIntegrationUserSettingsDelete {
        callRailIntegration {
            isEnabledForUser
            integrationType
        }
    }
}
